import { PositionType } from '../../../../types/common.types';

const descriptionMockData =
  'Rest assured, we are waiving change fees on Delta bookings through June 30, 2020. Valid for all destinations served by Delta, this waiver allows a change.';
const headerTextMockData = 'Book Confidently with No Change Fees';
const mobileImageMockData =
  'https://st.delta.com/content/dam/delta-applications/air-shopping/flightResults/dynamicBanner/Alert.svg';
const mobileImageAltMockData = 'No change fee';
const desktopImageMockData =
  'https://st.delta.com/content/dam/delta-applications/air-shopping/flightResults/dynamicBanner/Alert.svg';
const desktopImageAltMockData = 'No change fee';

export const alertImageBannerMockConfig = {
  deviceConfig: {
    desktopEnabled: true,
    mobileEnabled: true,
    responsive: true
  },
  templateType: 'alertbanner'
};

const imageMockContent = {
  desktop: {
    alt: desktopImageAltMockData,
    src: desktopImageMockData
  },
  mobile: {
    alt: mobileImageAltMockData,
    src: mobileImageMockData
  }
};
export const alertImageBannerMockContent = {
  imageContent: imageMockContent,
  description: descriptionMockData,
  headerText: headerTextMockData,
  level: '3'
};
export const alertImageBannerMockStyle = {
  banner: { backgroundColor: '', borderColor: '' },
  heading: {
    color: '#0B1F66',
    position: 'left' as PositionType
  },
  description: {
    color: '#0B1F66',
    position: 'left' as PositionType
  },
  badge: {
    position: 'left' as PositionType
  },
  textPosition: {
    position: 'right' as PositionType
  }
};
export const bannerAlertStoryNotes = 'This will display a alert banner.';
export const bannerAlertStoryData = {
  content: alertImageBannerMockContent,
  config: {
    deviceConfig: {
      desktopEnabled: true,
      mobileEnabled: true,
      responsive: true
    }
  },
  styles: alertImageBannerMockStyle
};
